import { chakra, Box, Flex } from "@chakra-ui/react";
import { colours, shadows } from "@shared/ui.design-system";

export const CountryModal = chakra(Box, {
  baseStyle: {
    backgroundColor: colours.accent.soft,
    position: "fixed",
    bottom: 0,
    width: "100vw",
    height: { base: "175px", lg: "160px" },
    zIndex: 9999,
    boxShadow: shadows.top.l1
  }
});

export const CountryModalContent = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    px: 2
  }
});
